/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_2_1Inputs */

const en_gc_search_guides_gridcraft_online_sections_3_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click a cell inside the editor first. For more room, use the full-screen or open-in-a-tab control.`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_table_rows_2_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_2_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先点击编辑器内部的单元格；需要更大空间时，使用全屏或在新标签页打开控件。`)
};

/**
* | output |
* | --- |
* | "Click a cell inside the editor first. For more room, use the full-screen or open-in-a-tab control." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_2_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_table_rows_2_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_2_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_Table_Rows_2_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_table_rows_2_1(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_table_rows_2_1(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_table_rows_2_1 as "gc.search_guides.gridcraft_online.sections.3.table.rows.2.1" }